import axios from 'axios';

export default axios.create({
    baseURL:"https://json-server-v17.onrender.com"
})
